import { css } from "@emotion/css";
import { DefaultEventsMap } from "@socket.io/component-emitter";
import authApi from "apis/authApi";
import gameApi from "apis/gameApi";
import BoardDesktop from "board-desktop";
import BoardMobile from "board-mobile";
import { RootState, useAppDispatch, useAppSelector } from "cache/store";
import CloseGame from "components/CloseGame";
import Modal from "components/modal/Modal";
import { login, logout } from "features/authSlice";
import { updateStatusSocket } from "features/socketSlice";
import { GameInstance, GameInstanceHistory, GameInstanceHistoryOddEven, StatsCount, TabGameItem, UserInfo } from "models/gameModel";
import { useEffect, useRef, useState } from "react";
import { isMobile } from "react-device-detect";
import { useNavigate, useSearchParams } from "react-router-dom";
import { io, Socket } from "socket.io-client";
import { calcstats, calcstatsTX } from "utils/common";
export let socketInstant: Socket<DefaultEventsMap, DefaultEventsMap>;

const urlMinigame = process.env.REACT_APP_MINIGAME_URL;

const tabGame: TabGameItem[] = [
	{
		label: "XÓC DĨA",
		isReady: true,
		value: "3",
		path: "xd-live",
		icon: require("assets/images/icons/tab-xd.png"),
	},
	{
		label: "TÀI XỈU",
		isReady: true,
		value: "5",
		path: "tx-live",
		icon: require("assets/images/icons/tab-tx.png"),
	},
	{
		label: "BACCARAT",
		isReady: false,
		value: "BACCARAT",
		path: "bcr-live",
		icon: require("assets/images/icons/tab-bcr.png"),
	},
];

let timerCheckConnectSocket: any = null;

function App() {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	const [searchParams] = useSearchParams();

	const encrypted: string = searchParams.get("encrypted") || "";
	const redirectUr: string = searchParams.get("from") || "";

	const { token } = useAppSelector((state: RootState) => state.auth);

	const [tabActive, setTabActive] = useState(tabGame[0]);
	const [gameList, setGameList] = useState<GameInstance[]>([]);
	const [gameAll, setGameAll] = useState<GameInstance[]>([]);
	const [balance, setBalance] = useState(0);
	const [historyIssue, setHistoryIssue] = useState({} as GameInstanceHistory);
	const [totalOddEven, setTotalOddEven] = useState({} as GameInstanceHistoryOddEven);
	const [showFailAuth, setShowFailAuth] = useState(false);
	const [showOutGame, setShowOutGame] = useState(false);

	useEffect(() => {
		//init login game
		if (encrypted) {
			const payload = {
				encrypted,
				device_name: "web",
			};
			const initGame = async () => {
				try {
					const { data } = await authApi.login(payload);
					if (data.code === 200) {
						console.log("login-------->", data.data);
						dispatch(login(data.data));
						navigate("/", { replace: true });
					}
				} catch (error) {
					console.log(error);
				}
			};
			initGame();
		} else if (token) {
			navigate("/", { replace: true });
		}

		handleResize();

		window.addEventListener("resize", handleResize);
		window.addEventListener("blur", onWindowBlur);
		window.addEventListener("focus", onWindowFocus);

		return () => {
			window.removeEventListener("resize", handleResize);
			window.removeEventListener("blur", onWindowBlur);
			window.removeEventListener("focus", onWindowFocus);
		};
	}, []);

	useEffect(() => {
		if (redirectUr) {
			localStorage.setItem("fromUrl", redirectUr);
		}
	}, [redirectUr]);

	useEffect(() => {
		if (!encrypted && !token) {
			dispatch(logout());
			setShowFailAuth(true);
		}
	}, [encrypted, token]);

	useEffect(() => {
		if (gameList.length > 0) {
			gameList.forEach(async (game) => {
				const data = await getHistoryIssue(game.id);
				setHistoryIssue((list) => ({ ...list, [game.id]: data }));

				const statsInit = {} as StatsCount;
				let statsCount = {} as StatsCount;
				if (tabActive.path === "xd-live") {
					statsCount = calcstats(data, statsInit);
				} else if (tabActive.path === "tx-live") {
					statsCount = calcstatsTX(data, statsInit);
				}
				setTotalOddEven((list) => ({ ...list, [game.id]: statsCount }));
			});
		}
	}, [gameList]);

	//connect socket
	useEffect(() => {
		if (token && !socketInstant) {
			getAllGame(tabActive.value, gameList);
			getBalance();

			socketInstant = io(process.env.REACT_APP_NODE_URL as any, {
				transports: ["websocket"],
				auth: {
					token: "Bearer " + token,
				},
			});

			socketInstant.on("connect", () => {
				console.log("=============socket connected===============");
				dispatch(updateStatusSocket(true));
			});

			socketInstant.on("disconnect", (reason) => {
				console.log("=============SOCKET DISCONNECT=============");
				closeGame();
				setShowOutGame(true);
			});

			socketInstant.on("connect_error", (err) => {
				console.log(`connect_error due to ${err.message}`);
				setShowFailAuth(true);
			});
		}
	}, [token]);

	const closeGame = () => {
		if (socketInstant) {
			socketInstant.disconnect();
			dispatch(updateStatusSocket(false));
		}
	};

	const handleResize = () => {
		if (!isMobile) {
			document.body.classList.add("desktop-body");
			const rootEl = document.getElementById("root") as HTMLDivElement;
			const scaleWidth = window.innerWidth / rootEl.offsetWidth;
			const scaleHight = window.innerHeight / rootEl.offsetHeight;
			document.body.style.transformOrigin = `0px 0px`;
			document.body.style.transform = `scale(${scaleWidth > scaleHight ? scaleHight : scaleWidth}) translateX(-50%)`;
		} else {
			document.body.classList.add("mobile-body");
		}
	};

	const getBalance = async () => {
		try {
			const { data } = await gameApi.getBalance();
			if (data.code === 200) {
				setBalance(data.data.balance);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getHistoryIssue = async (gameTypeId: number) => {
		try {
			const { data } = await gameApi.getHistoryIssue({ game_instance_id: gameTypeId, limit: 80, basic: true });
			if (data.code === 200) {
				return data.data.items;
			}
		} catch (error) {
			console.log(error);
		}
	};

	const getAllGame = async (gameType: string | number, gameData: GameInstance[]) => {
		if (gameData.length > 0) {
			const gamesActive = gameData.filter((game) => game.type.id === Number(gameType));
			setGameList(gamesActive);
		} else {
			try {
				const { data } = await gameApi.getAllGame({ is_live: true });
				if (data.code === 200) {
					setGameAll(data.data.items);
					const gamesActive = data.data.items.filter((game: GameInstance) => game.type.id === Number(gameType));
					setGameList(gamesActive);
				}
			} catch (error) {
				console.log(error);
			}
		}
	};

	const changeTabGame = (tab: TabGameItem) => {
		if (!tab.isReady) return;
		setTabActive(tab);
		getAllGame(tab.value, gameAll);
	};

	const launchGame = async (gameId: number) => {
		if (token) {
			window.location.href = `${urlMinigame}/${tabActive.path}/?gid=${gameId}`;
		}
	};

	const goBackHome = () => {
		window.location.href = localStorage.getItem("fromUrl") || "https://alobet88.com";
	};

	const onWindowBlur = () => {
		if (socketInstant) {
			timerCheckConnectSocket = setTimeout(() => {
				socketInstant.disconnect();
			}, 120000);
		}
	};

	const onWindowFocus = () => {
		clearTimeout(timerCheckConnectSocket);
	};

	return (
		<>
			{showFailAuth && (
				<div className={styles.verifyFail}>
					<img src={require("assets/images/logo.png")} alt="" />
					<p>Xác thực thất bại, Vui lòng mở lại game.</p>
				</div>
			)}
			{isMobile ? (
				<BoardMobile
					balance={balance}
					gamesActive={gameList}
					gameAll={gameAll}
					historyIssue={historyIssue}
					launchGame={launchGame}
					onChangeTab={changeTabGame}
					tabActive={tabActive}
					tabGame={tabGame}
					totalOddEven={totalOddEven}
					onGoBack={goBackHome}
				/>
			) : (
				<BoardDesktop
					balance={balance}
					gamesActive={gameList}
					gameAll={gameAll}
					historyIssue={historyIssue}
					launchGame={launchGame}
					onChangeTab={changeTabGame}
					tabActive={tabActive}
					tabGame={tabGame}
					totalOddEven={totalOddEven}
					onGoBack={goBackHome}
				/>
			)}

			<Modal isShow={showOutGame} onClose={() => setShowOutGame(false)} width={isMobile ? "90%" : "500px"}>
				<CloseGame />
			</Modal>
		</>
	);
}

const styles = {
	verifyFail: css`
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		flex-direction: column;
		gap: 16px;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: #292929;
		z-index: 100;
		p {
			color: #fdec81;
			font-size: 20px;
		}
		img {
			width: 200px;
		}
	`,
};

export default App;
